import { render, staticRenderFns } from "./DocumentRedirect.vue?vue&type=template&id=3e352dfe&scoped=true&"
import script from "./DocumentRedirect.vue?vue&type=script&lang=js&"
export * from "./DocumentRedirect.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRedirect.vue?vue&type=style&index=0&id=3e352dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e352dfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
